import { Spinner } from "@chakra-ui/react";
import { useIdTokenQuery } from "./index.generated";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useContext, useEffect } from "react";
import { AuthContext } from "~/App";
import { GraphqlClientContext } from "~/main";

export const Redirect = () => {
  const [searchParams] = useSearchParams();
  const { refreshGraphqlClient } = useContext(GraphqlClientContext);
  const { refetchUserAuth } = useContext(AuthContext);
  const navigate = useNavigate();
  const code = searchParams.get("code");

  useEffect(() => {
    refreshGraphqlClient();
  }, []);
  if (!code) {
    return <>Invalid Request</>;
  }
  const [getJwtTokenRes] = useIdTokenQuery({
    variables: {
      code,
    },
  });

  useEffect(() => {
    if (getJwtTokenRes.data?.userIdToken.jwtToken) {
      localStorage.setItem(
        "jwt_token",
        getJwtTokenRes.data.userIdToken.jwtToken
      );
      refetchUserAuth()
        .then(() => {
          navigate("/");
        })
        .catch(() => {
          navigate("/login");
        });
    }
  }, [getJwtTokenRes]);

  return <Spinner />;
};
